(() => {
  const roots = document.querySelectorAll('[data-hof-venue]');
  if (!roots.length) return;
  const sdk = window.supabase;
  const esc = (v='') => String(v).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));

  const validHex = (v,fallback) => /^#[0-9a-f]{6}$/i.test(String(v||'')) ? String(v) : fallback;
  const rgb = hex => { const h=validHex(hex,'#111827').slice(1); return [parseInt(h.slice(0,2),16),parseInt(h.slice(2,4),16),parseInt(h.slice(4,6),16)]; };
  const readableOn = hex => { const [r,g,b]=rgb(hex).map(v=>v/255),lin=v=>v<=.03928?v/12.92:Math.pow((v+.055)/1.055,2.4),L=.2126*lin(r)+.7152*lin(g)+.0722*lin(b); return L>.52?'#111827':'#ffffff'; };
  function applyTheme(root,fanbase,venue){
    const primary=validHex(fanbase?.primary_color,validHex(venue?.primary_color,'#111827'));
    const secondary=validHex(fanbase?.secondary_color,'#ffffff');
    const accent=validHex(fanbase?.accent_color,validHex(venue?.accent_color,secondary==='#ffffff'?'#f5b700':secondary));
    root.style.setProperty('--hof-team-primary',primary);
    root.style.setProperty('--hof-team-secondary',secondary);
    root.style.setProperty('--hof-team-accent',accent);
    root.style.setProperty('--hof-team-on-primary',readableOn(primary));
    root.style.setProperty('--hof-team-on-accent',readableOn(accent));
    root.dataset.fanbaseName=fanbase?.name||'';
  }
  async function loadVenueTheme(state){
    const {data,error}=await state.client.from('hof_live_venue_fanbases')
      .select('is_primary,hof_live_fanbases(id,name,primary_color,secondary_color,accent_color)')
      .eq('venue_id',state.venue.id);
    const rows=error?[]:(data||[]);
    const picked=(rows.find(x=>x.is_primary)?.hof_live_fanbases)||rows[0]?.hof_live_fanbases||null;
    state.theme=picked;
    applyTheme(state.root,picked,state.venue);
  }
  roots.forEach(root => boot(root));

  async function boot(root){
    const url = root.dataset.supabaseUrl;
    const key = root.dataset.supabaseKey;
    if(!sdk || !url || !key){
      root.innerHTML = '<div class="hof-venue-card hof-venue-login"><h2>Venue Portal setup required</h2><p>Add the Supabase project URL and publishable key to this Shopify section.</p></div>';
      return;
    }
    const state = {
      root,
      client: sdk.createClient(url,key),
      venues: [],
      venue: null,
      events: [],
      sessions: new Map(),
      gameSets: new Map(),
      user: null,
      admin: null,
      reviewEventId: null,
      reviewQuestions: [],
      theme: null,
      urls: {
        screen: root.dataset.screenUrl || '/pages/hall-of-fan-live-screen',
        admin: root.dataset.adminUrl || '/pages/hall-of-fan-live-master'
      }
    };
    const {data:{user}} = await state.client.auth.getUser();
    if(!user || user.is_anonymous) return renderLogin(state);
    try { await enterPortal(state,user); }
    catch(e){ renderLogin(state,e.message); }
  }

  function renderLogin(state,error=''){
    state.root.innerHTML = `<div class="hof-venue-shell hof-venue-login-shell">
      <div class="hof-venue-card hof-venue-login">
        <div class="hof-venue-kicker">Hall Of Fan Live</div>
        <h1>Venue Login</h1>
        <p>Sign in. Then press <b>Launch Game</b>. The game screen opens immediately on Question 1. Players can join from the QR code on screen.</p>
        <form class="hof-venue-form" data-venue-login>
          <label>Email<input name="email" type="email" autocomplete="username" required></label>
          <label>Password<input name="password" type="password" autocomplete="current-password" required></label>
          <button class="hof-venue-btn primary big" type="submit">SIGN IN</button>
          <div class="hof-venue-msg" data-login-msg>${esc(error)}</div>
        </form>
      </div>
    </div>`;
    state.root.querySelector('[data-venue-login]').onsubmit = async e => {
      e.preventDefault();
      const form = e.currentTarget;
      const msg = form.querySelector('[data-login-msg]');
      msg.textContent = 'Signing in…';
      const fd = new FormData(form);
      const {data,error} = await state.client.auth.signInWithPassword({
        email: String(fd.get('email')||'').trim(),
        password: String(fd.get('password')||'')
      });
      if(error){ msg.textContent = error.message; return; }
      try { await enterPortal(state,data.user); }
      catch(err){ msg.textContent = err.message || 'This account does not have Venue access.'; }
    };
  }

  async function enterPortal(state,user){
    state.user = user;
    const [{data:admin,error:ae},{data:staff,error:se}] = await Promise.all([
      state.client.from('hof_live_platform_admins').select('auth_user_id,display_name,role').eq('auth_user_id',user.id).maybeSingle(),
      state.client.from('hof_live_hosts').select('id,venue_id,display_name,role,hof_live_venues(id,name,slug,timezone,city,state,primary_color,accent_color,is_active)').eq('auth_user_id',user.id).order('created_at')
    ]);
    if(ae) throw ae;
    if(se) throw se;
    state.admin = admin || null;
    if(admin){
      const {data,error} = await state.client.from('hof_live_venues').select('id,name,slug,timezone,city,state,primary_color,accent_color,is_active').eq('is_active',true).order('name');
      if(error) throw error;
      state.venues = data || [];
    } else {
      state.venues = (staff||[]).map(x=>x.hof_live_venues).filter(Boolean);
    }
    if(!state.venues.length) throw new Error('This login is valid, but it has not been assigned Venue access yet.');
    const requested = new URLSearchParams(location.search).get('venue');
    state.venue = state.venues.find(v=>v.id===requested || v.slug===requested) || state.venues[0];
    await loadVenueTheme(state);
    await loadSchedule(state);
    const params=new URLSearchParams(location.search);
    const reviewEvent=params.get('event');
    if(params.get('review')==='1' && reviewEvent && state.events.some(e=>e.id===reviewEvent)){
      await openQuestionReview(state,reviewEvent);
      return;
    }
    renderHome(state);
  }

  async function loadSchedule(state){
    const now = Date.now();
    const lo = new Date(now - 2*86400000).toISOString();
    const hi = new Date(now + 14*86400000).toISOString();
    const {data:events,error} = await state.client.from('hof_live_events')
      .select('id,title,starts_at,status,venue_id,fanbase_id,game_set_id')
      .eq('venue_id',state.venue.id)
      .gte('starts_at',lo)
      .lte('starts_at',hi)
      .order('starts_at');
    if(error) throw error;
    state.events = events || [];
    const eventIds = state.events.map(e=>e.id);
    state.sessions = new Map();
    if(eventIds.length){
      const {data:sessions,error:se} = await state.client.from('hof_live_sessions').select('*').in('event_id',eventIds);
      if(se) throw se;
      (sessions||[]).forEach(s=>state.sessions.set(s.event_id,s));
    }
    const gameSetIds = [...new Set(state.events.map(e=>e.game_set_id).filter(Boolean))];
    state.gameSets = new Map();
    if(gameSetIds.length){
      const {data:sets} = await state.client.from('hof_live_game_sets').select('id,name,duration_minutes').in('id',gameSetIds);
      (sets||[]).forEach(g=>state.gameSets.set(g.id,g));
    }
  }

  function renderHome(state){
    const tz = state.venue.timezone || 'America/Denver';
    const today = todayKey(tz);
    const todaysGames = state.events.filter(e=>dateKey(new Date(e.starts_at),tz)===today);
    const upcoming = state.events.filter(e=>dateKey(new Date(e.starts_at),tz)>=today).slice(0,8);
    const hero = todaysGames.length
      ? todaysGames.map(e=>launchCard(state,e,true)).join('')
      : `<div class="hof-launch-empty"><div class="hof-venue-kicker">No game scheduled today</div><h2>You're all set.</h2><p>The next scheduled trivia game appears below.</p></div>`;

    state.root.innerHTML = `<div class="hof-venue-shell">
      ${shellTop(state)}
      <section class="hof-launch-hero">
        <div class="hof-venue-kicker">${esc(state.venue.name)}${state.venue.city?' · '+esc(state.venue.city):''}</div>
        <h1>Launch Tonight's Game</h1>
        <p class="hof-launch-instruction">One button. Question 1 starts immediately with a 60-second clock. Trivia then runs automatically.</p>
        <div class="hof-launch-stack">${hero}</div>
      </section>

      <section class="hof-upcoming-wrap">
        <div class="hof-upcoming-head"><div><div class="hof-venue-kicker">Schedule</div><h2>Upcoming Games</h2></div></div>
        <div class="hof-upcoming-list">
          ${upcoming.length ? upcoming.map(e=>scheduleRow(state,e,tz,today)).join('') : '<div class="hof-venue-card"><p class="hof-note">No upcoming trivia games are scheduled yet.</p></div>'}
        </div>
      </section>
    </div>`;

    bindTop(state);
    state.root.querySelectorAll('[data-review-event]').forEach(btn=>{
      btn.onclick = () => openQuestionReview(state,btn.dataset.reviewEvent);
    });
    state.root.querySelectorAll('[data-launch-event]').forEach(btn=>{
      btn.onclick = () => launchGame(state,btn.dataset.launchEvent,btn);
    });
    state.root.querySelectorAll('[data-pause-event]').forEach(btn=>{
      btn.onclick = () => togglePause(state,btn.dataset.pauseEvent,btn);
    });
  }

  function shellTop(state){
    const venueSwitcher = state.venues.length>1
      ? `<select class="hof-venue-select compact" data-venue-switch>${state.venues.map(v=>`<option value="${v.id}" ${v.id===state.venue.id?'selected':''}>${esc(v.name)}</option>`).join('')}</select>`
      : `<span class="hof-venue-name">${esc(state.venue.name)}</span>`;
    return `<div class="hof-venue-top simplified">
      <div class="hof-venue-brand"><small>Hall Of Fan Live</small><h1>Venue</h1></div>
      <div class="hof-venue-user">${venueSwitcher}${state.admin?`<a class="hof-venue-linkbtn" href="${esc(state.urls.admin)}">ADMIN</a>`:''}<button class="hof-venue-btn" data-venue-signout>SIGN OUT</button></div>
    </div>`;
  }

  function bindTop(state){
    const out = state.root.querySelector('[data-venue-signout]');
    if(out) out.onclick = async()=>{ await state.client.auth.signOut(); renderLogin(state); };
    const sw = state.root.querySelector('[data-venue-switch]');
    if(sw) sw.onchange = async()=>{
      state.venue = state.venues.find(v=>v.id===sw.value) || state.venue;
      await loadVenueTheme(state);
      await loadSchedule(state);
      renderHome(state);
    };
  }

  function launchCard(state,event,isToday){
    const session = state.sessions.get(event.id);
    const game = state.gameSets.get(event.game_set_id);
    const tz = state.venue.timezone || 'America/Denver';
    const status = sessionStatus(session,event);
    const code = session?.join_code || '';
    const alreadyStarted = !!(session?.auto_run_enabled && session?.run_started_at);
    const disabled = !isToday || !session || !code || session?.status==='finished' || session?.auto_run_state==='finished';
    const label = session?.status==='finished' || session?.auto_run_state==='finished'
      ? 'GAME COMPLETE'
      : alreadyStarted ? 'RETURN TO GAME' : 'LAUNCH GAME';
    const helper = !session
      ? 'This game still needs a Live session from Trivia Admin.'
      : !code
      ? 'This session does not have a join code yet.'
      : alreadyStarted
      ? 'The game is already active. Return directly to the Game Screen.'
      : 'Press Start Game. Question 1 opens immediately on the Game Screen.';
    return `<article class="hof-launch-card ${disabled?'is-disabled':''}">
      <div class="hof-launch-card-main">
        <div class="hof-launch-time">${esc(formatTime(event.starts_at,tz))}</div>
        <h2>${esc(event.title||'Trivia Night')}</h2>
        <p>${esc(game?.name || 'Hall Of Fan Live Trivia')}</p>
        <div class="hof-launch-meta">
          <span class="hof-status ${esc(status.toLowerCase())}">${esc(status)}</span>
          ${code?`<span>JOIN CODE <b>${esc(code)}</b></span>`:''}
          ${game&&game.duration_minutes!=null?`<span>${Number(game.duration_minutes)===0?'UNTIMED':Number(game.duration_minutes)===60?'1 HOUR':Number(game.duration_minutes)+' MIN'}</span>`:''}
        </div>
      </div>
      <div class="hof-launch-action">
        ${!alreadyStarted && session && code && !disabled ? `<button class="hof-venue-btn review" data-review-event="${event.id}">REVIEW QUESTIONS</button>` : ''}
        <button class="hof-venue-btn gold launch" data-launch-event="${event.id}" ${disabled?'disabled':''}>${esc(label)}</button>
        ${alreadyStarted && !disabled ? `<button class="hof-venue-btn pause-game" data-pause-event="${event.id}">${session?.pause_started_at || session?.auto_run_state==='paused' ? 'RESUME GAME' : 'PAUSE QUESTION'}</button>` : ''}
        <small>${esc(helper)}</small>
      </div>
    </article>`;
  }

  function scheduleRow(state,event,tz,today){
    const session = state.sessions.get(event.id);
    const key = dateKey(new Date(event.starts_at),tz);
    const isToday = key===today;
    const game = state.gameSets.get(event.game_set_id);
    return `<article class="hof-schedule-row ${isToday?'is-today':''}">
      <div class="hof-schedule-date"><b>${esc(shortDay(event.starts_at,tz))}</b><span>${esc(shortDate(event.starts_at,tz))}</span></div>
      <div class="hof-schedule-title"><b>${esc(event.title||'Trivia Night')}</b><span>${esc(game?.name||'Trivia')}</span></div>
      <div class="hof-schedule-time">${esc(formatTime(event.starts_at,tz))}</div>
      <span class="hof-status ${esc(sessionStatus(session,event).toLowerCase())}">${esc(sessionStatus(session,event))}</span>
      ${isToday && session?.join_code ? `<div class="hof-schedule-actions">${!session?.auto_run_enabled?`<button class="hof-venue-btn" data-review-event="${event.id}">REVIEW</button>`:''}<button class="hof-venue-btn" data-launch-event="${event.id}">${session?.auto_run_enabled?'RETURN':'LAUNCH'}</button>${session?.auto_run_enabled?`<button class="hof-venue-btn pause-game" data-pause-event="${event.id}">${session?.pause_started_at || session?.auto_run_state==='paused'?'RESUME':'PAUSE'}</button>`:''}</div>` : ''}
    </article>`;
  }

  async function openQuestionReview(state,eventId){
    const event=state.events.find(e=>e.id===eventId);
    const session=state.sessions.get(eventId);
    if(!event||!session?.id){alert('This game does not have a Live session yet.');return;}
    if(session.auto_run_enabled||session.run_started_at||['live','paused','finished'].includes(session.status)){
      alert('Question wording locks once the game is launched.');return;
    }
    const {data,error}=await state.client.from('hof_live_session_questions')
      .select('id,session_id,question_id,sort_order,round_label,prompt_override,wording_edited_at,hof_live_questions(id,prompt,question_format,category,difficulty)')
      .eq('session_id',session.id).order('sort_order');
    if(error){alert(error.message);return;}
    state.reviewEventId=eventId;
    state.reviewQuestions=data||[];
    renderQuestionReview(state,event,session);
  }

  function renderQuestionReview(state,event,session){
    const rows=state.reviewQuestions||[];
    state.root.innerHTML=`<div class="hof-venue-shell hof-review-shell">
      ${shellTop(state)}
      <section class="hof-review-head">
        <button class="hof-venue-btn" data-review-back>← THIS WEEK'S GAMES</button>
        <div class="hof-venue-kicker">Pre-Launch Review</div>
        <h1>Review Question Wording</h1>
        <p>Edit how each question will appear on the TV and player phones for <b>${esc(event.title||'tonight’s trivia')}</b>. Answers, scoring, sources and sponsor assignments are not changed.</p>
        <div class="hof-review-actions">
          <button class="hof-venue-btn primary" data-save-all-wording>SAVE CHANGES</button>
          <button class="hof-venue-btn gold" data-review-launch="${event.id}">LAUNCH GAME</button>
        </div>
        <div class="hof-review-status" data-review-status>${rows.length} questions ready to review.</div>
      </section>
      <section class="hof-review-list">
        ${rows.map((r,i)=>{const q=r.hof_live_questions||{};const current=r.prompt_override||q.prompt||'';return `<article class="hof-review-question" data-review-row="${r.question_id}">
          <div class="hof-review-qtop"><span>QUESTION ${i+1} OF ${rows.length}</span><span>${esc(r.round_label||q.category||'Trivia')} · ${esc(String(q.question_format||'question').replace(/_/g,' ').toUpperCase())}</span></div>
          <textarea maxlength="600" data-wording-input="${r.question_id}" data-saved="${esc(current)}">${esc(current)}</textarea>
          ${r.prompt_override?`<div class="hof-review-original"><b>Original:</b> ${esc(q.prompt||'')}</div>`:''}
          <div class="hof-review-qactions">
            <button class="hof-venue-btn" data-save-wording="${r.question_id}">SAVE QUESTION</button>
            ${r.prompt_override?`<button class="hof-venue-btn" data-reset-wording="${r.question_id}">RESET TO ORIGINAL</button>`:''}
            <span>${r.wording_edited_at?'Edited for this game':'Using original wording'}</span>
          </div>
        </article>`}).join('')||'<div class="hof-venue-card"><p>No questions are assigned to this game yet.</p></div>'}
      </section>
      ${rows.length?`<div class="hof-review-bottom"><button class="hof-venue-btn primary" data-save-all-wording>SAVE CHANGES</button><button class="hof-venue-btn gold" data-review-launch="${event.id}">LAUNCH GAME</button></div>`:''}
    </div>`;
    bindTop(state);
    state.root.querySelectorAll('[data-review-back]').forEach(b=>b.onclick=()=>renderHome(state));
    state.root.querySelectorAll('[data-save-wording]').forEach(b=>b.onclick=()=>saveOneWording(state,session,b.dataset.saveWording,b));
    state.root.querySelectorAll('[data-reset-wording]').forEach(b=>b.onclick=()=>resetOneWording(state,event,session,b.dataset.resetWording,b));
    state.root.querySelectorAll('[data-save-all-wording]').forEach(b=>b.onclick=()=>saveAllWording(state,session,b));
    state.root.querySelectorAll('[data-review-launch]').forEach(b=>b.onclick=()=>launchFromReview(state,event,session,b));
  }

  async function saveOneWording(state,session,questionId,button){
    const input=state.root.querySelector(`[data-wording-input="${questionId}"]`);
    const prompt=String(input?.value||'').trim();
    if(prompt.length<5){alert('Question wording must be at least 5 characters.');return false;}
    const old=button?.textContent;
    if(button){button.disabled=true;button.textContent='SAVING…';}
    const {data,error}=await state.client.rpc('hof_live_update_session_question_prompt',{p_session_id:session.id,p_question_id:questionId,p_prompt:prompt});
    if(error){if(button){button.disabled=false;button.textContent=old||'SAVE QUESTION';}alert(error.message);return false;}
    if(input)input.dataset.saved=data?.prompt||prompt;
    const row=state.reviewQuestions.find(x=>x.question_id===questionId);if(row){row.prompt_override=data?.is_override?data.prompt:null;row.wording_edited_at=data?.is_override?new Date().toISOString():null;}
    if(button){button.disabled=false;button.textContent='SAVED ✓';setTimeout(()=>button.textContent=old||'SAVE QUESTION',900);}
    return true;
  }

  async function persistChangedWording(state,session){
    const inputs=[...state.root.querySelectorAll('[data-wording-input]')];
    const changed=inputs.filter(i=>String(i.value).trim()!==String(i.dataset.saved||'').trim());
    let saved=0;
    for(const input of changed){
      const prompt=String(input.value||'').trim();
      if(prompt.length<5)throw new Error(`Question ${inputs.indexOf(input)+1} is too short.`);
      const {data,error}=await state.client.rpc('hof_live_update_session_question_prompt',{p_session_id:session.id,p_question_id:input.dataset.wordingInput,p_prompt:prompt});
      if(error)throw error;
      input.dataset.saved=data?.prompt||prompt;saved++;
      const row=state.reviewQuestions.find(x=>x.question_id===input.dataset.wordingInput);if(row){row.prompt_override=data?.is_override?data.prompt:null;row.wording_edited_at=data?.is_override?new Date().toISOString():null;}
    }
    return saved;
  }

  async function saveAllWording(state,session,button){
    const status=state.root.querySelector('[data-review-status]');
    const old=button.textContent;button.disabled=true;button.textContent='SAVING…';
    try{
      const saved=await persistChangedWording(state,session);
      button.textContent='SAVED ✓';
      if(status)status.textContent=saved?`${saved} wording change${saved===1?'':'s'} saved for this game.`:'No unsaved wording changes.';
      setTimeout(()=>{button.disabled=false;button.textContent=old},1000);
      return true;
    }catch(e){alert(e.message||'Could not save question wording.');button.disabled=false;button.textContent=old;return false;}
  }

  async function launchFromReview(state,event,session,button){
    const old=button.textContent;button.disabled=true;button.textContent='SAVING & LAUNCHING…';
    try{
      await persistChangedWording(state,session);
      await launchGame(state,event.id,button);
    }catch(e){alert(e.message||'Could not save wording before launch.');button.disabled=false;button.textContent=old;}
  }

  async function resetOneWording(state,event,session,questionId,button){
    if(!confirm('Reset this question to the original wording?'))return;
    button.disabled=true;button.textContent='RESETTING…';
    const {error}=await state.client.rpc('hof_live_update_session_question_prompt',{p_session_id:session.id,p_question_id:questionId,p_prompt:null});
    if(error){alert(error.message);button.disabled=false;button.textContent='RESET TO ORIGINAL';return;}
    await openQuestionReview(state,event.id);
  }

  async function launchGame(state,eventId,button){
    const event = state.events.find(e=>e.id===eventId);
    const session = state.sessions.get(eventId);
    if(!event || !session || !session.join_code){
      alert('This game is not ready yet. Trivia Admin needs to attach a Live session first.');
      return;
    }
    try{
      button.disabled = true;
      button.textContent = session.auto_run_enabled ? 'OPENING GAME…' : 'LAUNCHING…';
      if(!session.auto_run_enabled || !session.run_started_at){
        const {count,error:qe} = await state.client.from('hof_live_session_questions').select('id',{count:'exact',head:true}).eq('session_id',session.id);
        if(qe) throw qe;
        if(!count) throw new Error('This quiz has no questions yet. Generate or assign the quiz in Trivia Admin first.');
        const {error} = await state.client.rpc('hof_live_start_trivia',{p_session_id:session.id});
        if(error) throw error;
      }
      const dest = `${state.urls.screen}?code=${encodeURIComponent(session.join_code)}&venue_control=1`;
      location.assign(dest);
    }catch(e){
      alert(e.message || 'Could not launch the game.');
      button.disabled = false;
      button.textContent = session.auto_run_enabled ? 'RETURN TO GAME' : 'LAUNCH GAME';
    }
  }

  async function togglePause(state,eventId,button){
    const session=state.sessions.get(eventId);
    if(!session?.id){alert('This game is not running yet.');return;}
    const paused=!!(session.pause_started_at || session.auto_run_state==='paused');
    try{
      button.disabled=true;
      button.textContent=paused?'RESUMING…':'PAUSING…';
      const {error}=await state.client.rpc(paused?'hof_live_resume_trivia':'hof_live_pause_trivia',{p_session_id:session.id});
      if(error)throw error;
      await loadSchedule(state);
      renderHome(state);
    }catch(e){alert(e.message||'Could not change game state.');button.disabled=false;button.textContent=paused?'RESUME GAME':'PAUSE QUESTION';}
  }

  function sessionStatus(s,e){
    if(!s) return e.status || 'Scheduled';
    if(s.status==='finished' || s.auto_run_state==='finished') return 'Finished';
    if(s.pause_started_at || s.auto_run_state==='paused') return 'Paused';
    if(s.auto_run_enabled) return 'Live';
    return s.status==='lobby' ? 'Ready' : (s.status || e.status || 'Scheduled');
  }

  function dateKey(date,tz){
    const p = new Intl.DateTimeFormat('en-US',{timeZone:tz,year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(date);
    const x = Object.fromEntries(p.map(i=>[i.type,i.value]));
    return `${x.year}-${x.month}-${x.day}`;
  }
  function todayKey(tz){ return dateKey(new Date(),tz); }
  function formatTime(v,tz){ return new Intl.DateTimeFormat('en-US',{timeZone:tz,hour:'numeric',minute:'2-digit'}).format(new Date(v)); }
  function shortDay(v,tz){ return new Intl.DateTimeFormat('en-US',{timeZone:tz,weekday:'short'}).format(new Date(v)); }
  function shortDate(v,tz){ return new Intl.DateTimeFormat('en-US',{timeZone:tz,month:'short',day:'numeric'}).format(new Date(v)); }
})();
